import * as Crypto from "expo-crypto";

import Logging from "$src/core/services/logging/logging";
import SecureStorage from "$src/core/services/secure-storage";

const DEVICE_ID_KEY = "device.id" as const;

/**
 * Returns a stable device ID for this app install. UUID is generated
 * once and stored in SecureStore.
 */
const getStableDeviceId = (): string => {
  const stored = SecureStorage.get(DEVICE_ID_KEY);
  if (stored) return stored;

  const id = Crypto.randomUUID();

  // Persist best-effort: SecureStore.setItem is synchronous and can throw theoretically
  try {
    SecureStorage.set(DEVICE_ID_KEY, id);
  } catch (error) {
    Logging.error("Failed to persist device id", { error });
  }
  return id;
};

export default getStableDeviceId;
